; (function ($) {
    'use strict';
    $(document).ready(function () {
        smartSelect();
        clip();
        //smartTable();
        $.table_layout_fix();
        onShownTab();
        do_popover();
        stickTabs();
        fixedHeader();
        tableHover();
        // scroll_top();
        make_toggle();
        tabs_search();
        generalSearch();
        $('body').activate_popup();

        $('.f-header-nav__link').on('click', function (e) {
            e.preventDefault();
        });

        (function ($) {
            $.fn.datepicker.dates['ru'] = {
                days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"],
                daysShort: ["Вск", "Пнд", "Втр", "Срд", "Чтв", "Птн", "Суб", "Вск"],
                daysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"],
                months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
                monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
                today: "Сегодня",
                suffix: [],
                meridiem: []
            };
        }(jQuery));

        $('.is--datepicker').datepicker({
            autoclose: true,
            todayBtn: true,
            language: culture,
            templates: {
                leftArrow: '<i class="f-icon f-icon--arrow-prev-thin"></i>',
                rightArrow: '<i class="f-icon f-icon--arrow-next-thin"></i>'
            },
            zIndexOffset: 33
        });

        $('.f-clients-info a, .f-company2-info a, .f-vps-info a').on('click', function () {
            var $this = $(this),
                href = $this.attr('href');
            if (href.charAt(0) == '#') {
                $('.f-tabs a[href="' + href + '"]').trigger('click');
            } else if (window.location.href.indexOf(href.split('#')[0]) >= 0) {
                $('.f-tabs a[href="#' + href.split('#')[1] + '"]').trigger('click');
            }
        });

        $(document).on('click', 'textarea[readonly], input[type="text"][readonly]', function () {
            $(this)
                .focus()
                .select();
        });

        //$('.button-collapse-copy').on('click', function (e) {
        //    e.preventDefault();

        //    var $this = $(this),
        //        text = $this.find('.button__text'),
        //        done = $this.data('done');

        //    $this.addClass('disabled');
        //    text.width(text.outerWidth()).text(done);
        //});
    });
    MegaMenu();

    // -------------------------------------------------------------------------------------------
    // Activate select2
    // -------------------------------------------------------------------------------------------
    function smartSelect() {
        $('.select2').select2({
            minimumResultsForSearch: Infinity
        });

        $('.f-market__time select').each(function () {
            var $this = $(this),
                template = $this.data('template');

            $this.html(timezones_list());

            $(this).select2({
                minimumResultsForSearch: Infinity,
                templateSelection: function (state) {
                    var time = moment().tz(state.element.value).format('HH:mm'),
                        text = template.replace('{time}', time).replace('{value}', $(state.element).data('offset'));
                    return $.parseHTML(text);
                }
            }).on('select2:select', function (e) {

            });
        });
    }

    function get_timezones() {
        var timeZones = moment.tz.names(),
            tzList = [];

        for (var key in timeZones) {
            if (timeZones[key].indexOf('Etc') == -1) {
                tzList.push({
                    name: timeZones[key].substring(timeZones[key].indexOf("/") + 1).replace('_', ' '),
                    value: timeZones[key],
                    offset: moment.tz(timeZones[key]).format('Z')
                });
            }
        }

        tzList.sort(function (a, b) {
            return parseInt(a.offset.replace(":", ""), 10) - parseInt(b.offset.replace(":", ""), 10);
        });

        return tzList;
    }

    function timezones_list() {
        var currentTz = moment.tz.guess(),
            timeZones = get_timezones(),
            offsetTmz = [];

        for (var i in timeZones) {
            var city = timeZones[i],
                selected = (city.value == currentTz ? 'selected' : '');
            offsetTmz.push('<option ' + selected + ' value="' + city.value + '" data-offset="' + city.offset + '">(GMT ' + city.offset + ') ' + city.name + '</option>');
        }

        return offsetTmz;
    }

    // -------------------------------------------------------------------------------------------
    // Activate clipboard copy
    // -------------------------------------------------------------------------------------------
    function clip() {
        var clipboard = new Clipboard('[data-clipboard-target]');
        clipboard.on('success', function (e) {
            setTooltip(e.trigger);
            hideTooltip(e.trigger);
        });

        new Clipboard('.button-collapse-copy', {
            text: function (trigger) {
                return trigger.getAttribute('href');
            }
        });

        function setTooltip(el) {
            $(el).tooltip('hide').tooltip('show');
        }

        function hideTooltip(el) {
            setTimeout(function () {
                $(el).tooltip('dispose');
            }, 2000);
        }
    }

    // -------------------------------------------------------------------------------------------
    // Activate DataTables
    // -------------------------------------------------------------------------------------------
    //function smartTable() {
    //    $('.f-table--smart').each(function () {
    //        var table = $(this).DataTable({
    //            autoWidth: false,
    //            bAutoWidth: false,
    //            pagingType: 'ellipses',
    //            sDom: 'r<"DataTables_Table_container"t><"dataTables_nav"Li<"dataTables-paginate"p>>',
    //            bInfo: false,
    //            bSort: false,
    //            aLengthMenu: [
    //                [10, 50, 100, 200, -1],
    //                [10, 50, 100, 200, 'Все']
    //            ],
    //            iDisplayLength: 10,
    //            bSortCellsTop: true,
    //            initComplete: function () {
    //                var table = this;
    //                //Add text to paginate
    //                $(table.api().table().container()).find('.dataTables-paginate').prepend('<div class="dataTables_paginate__text">Страница</div>');
    //                //Bind search
    //                table.api().columns().every(function (idx) {
    //                    var column = this;
    //                    $(table).find('.table__search td').eq(idx).find('input').on('keyup change', function () {
    //                        var val = $(this).val();
    //                        column.search(val).draw();
    //                    });
    //                });
    //            },
    //            drawCallback: function (settings) {
    //                //Init api
    //                var api = this.api();

    //                //Get count of rows on current page and add alternate color for navigation
    //                var count = api.rows({
    //                    page: 'current'
    //                }).data().length;
    //                if (count % 2 == 0) {
    //                    $('.dataTables_nav').removeClass('dataTables_nav--alternate');
    //                } else {
    //                    $('.dataTables_nav').addClass('dataTables_nav--alternate');
    //                }
    //            },
    //            //Format numbers
    //            aoColumnDefs: [{
    //                aTargets: ['_all'],
    //                fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
    //                    if ($(nTd).hasClass('has--numbers')) {
    //                        var $currencyCell = $(nTd);
    //                        var commaValue = $currencyCell.text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ");
    //                        $currencyCell.text(commaValue);
    //                    }
    //                },
    //            }],
    //            language: {
    //                lengthMenu: '<span class="dataTables_length__text">Отображать на странице</span> _MENU_',
    //                paginate: {
    //                    first: 'Первая',
    //                    last: 'Последняя',
    //                    next: '<i class="f-icon f-icon--arrow-next"></i>',
    //                    previous: '<i class="f-icon f-icon--arrow-prev"></i>'
    //                }
    //            },
    //        });

    //        //Stick table head and 1st column
    //        var tabs = $('.f-tabs'),
    //            offset = tabs ? tabs.outerHeight() : 0;
    //        if (tabs && tabs.hasClass('f-tabs--multirow')) {
    //            offset = offset / 1.5;
    //        }
    //        if ($('.f-page').hasClass('f-page-rating')) { //temp disable sticky for non-rating page
    //            $(this).tableHeadFixer({
    //                'left': 1,
    //                'head': true,
    //                'z-index': 20,
    //                'topOffset': offset
    //            });
    //        }

    //        //For test columns
    //        $('.f-toggle__item [name="test"]').on('change', function () {
    //            if ($(this).is(':checked') && $(this).val() == '1') {
    //                $('.DataTables_Table_container').css({
    //                    'width': '1200px',
    //                    'margin': '0 auto'
    //                });
    //            } else {
    //                $('.DataTables_Table_container').css({
    //                    'width': '100%',
    //                    'margin': '0 auto'
    //                });
    //            }
    //            table.draw();
    //        });

    //        //Add highlight to columns
    //        $(this).on('mouseenter', 'tbody > tr > *', function () {
    //            var colIdx = table.cell(this).index().column;

    //            $(table.cells().nodes()).removeClass('is--highlight');
    //            //if columns ID is 0
    //            if (colIdx == 0) {
    //                $(this).addClass('is--highlight');
    //            } else {
    //                $(table.column(colIdx).nodes()).addClass('is--highlight');
    //            }
    //        }).on('mouseleave', function () {
    //            $(table.cells().nodes()).removeClass('is--highlight');
    //        });

    //        //temporary enable toggle for table titles
    //        $(table.table().header()).find('tr').eq(0).find('th').each(function () {
    //            var th = $(this),
    //                titleShort = th.data('title-short'),
    //                titleFull = th.data('title-full');
    //            $('.f-toggle__item [name="name"]').on('change', function () {
    //                if ($(this).is(':checked') && $(this).val() == 'full') {
    //                    var title = titleFull;
    //                } else {
    //                    var title = titleShort
    //                }
    //                th.text(title);
    //            });
    //        });

    //        //Temp short
    //        function format(d) {
    //            var content = '',
    //                add_child = function (value) {
    //                    var clone = $(d).clone();
    //                    clone.addClass('is--child is--' + value);
    //                    clone.find('.short_toggle').remove();
    //                    clone.find('th .f-quote__circle').attr('class', 'f-quote__line');
    //                    clone.find('th .f-quote__text').text(value.toUpperCase());
    //                    content += clone[0].outerHTML;
    //                };

    //            add_child('long');
    //            add_child('short');

    //            return content;
    //        }
    //        $(this).on('click', '.short_toggle', function (e) {
    //            e.preventDefault();
    //            var tr = $(this).closest('tr'),
    //                row = table.row(tr);

    //            if (row.child.isShown()) {
    //                // If row is already opened - close it
    //                row.child.hide();
    //                tr.removeClass('shown');
    //            } else {
    //                // Open this row
    //                row.child(format(row.node())).show();
    //                tr.addClass('shown');
    //            }
    //        });
    //    });
    //}

    // -------------------------------------------------------------------------------------------
    // Fix for table-layout:fixed
    // -------------------------------------------------------------------------------------------
    $.table_layout_fix = function () {
        $('.f-table--codename-jaguar').each(function () {
            var table = $(this),
                thead = table.find('thead'),
                columns = table.find('tbody tr:first-child .is--nowrap');
            columns.each(function () {
                var index = $(this).index(),
                    rows = table.find('tbody tr'),
                    Width = [],
                    padding = parseInt($(this).css('padding-right')) + parseInt($(this).css('padding-left')),
                    indexNew = index;
                if ($(this).siblings('[rowspan]').length) {
                    indexNew -= 1;
                }
                rows.each(function () {
                    var innerIndex = indexNew;
                    if ($(this).find('[rowspan]').length) {
                        innerIndex += 1;
                    }
                    Width.push($(this).find('>*').eq(innerIndex).find('span').width());
                });
                var maxWidth = Math.max.apply(null, Width) + padding;
                thead.find('tr >*').eq(index).outerWidth(maxWidth);
            });
        });
    };

    function onShownTab() {
        $(document).on('shown.bs.tab', '[data-toggle="tab"]', function (e) {
            var target = $(e.target).attr('href');
            //if (!target.startsWith("#"))
            if ($(target).find('.f-table--codename-jaguar').length) {
                $.table_layout_fix();
            }
        });

        $(document).on('show.bs.tab', '[data-toggle="tab"]', function (e) {
            var currentLayout = document.body.dataset.layout,
                nextLayout = e.target.dataset.layout;

            if (nextLayout && currentLayout !== nextLayout) {
                e.preventDefault();
                window.location.replace(e.target.href);
                window.location.reload();
            }
        });
    }
    // -------------------------------------------------------------------------------------------
    // Activate Bootstrap's popover
    // -------------------------------------------------------------------------------------------
    function do_popover() {
        $('[data-toggle="popover"]').popover({
            placement: 'bottom',
            html: true,
            animation: true,
            template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-border"></div><div class="popover-body"></div></div>'
        }).on('show.bs.popover', function () {
            $('[data-toggle="popover"]').not(this).popover('hide');
        });
    }

    // -------------------------------------------------------------------------------------------
    // Activate sticky tabs
    // -------------------------------------------------------------------------------------------
    function stickTabs() {
        $('.f-tabs').hashTabs();
        /*$('.f-tabs--fixed').stick_in_parent({
            parent: '.b-page',
            sticky_class: 'is-stuck'
        });*/
        $('[data-assist="tab"]').on('click', function () {
            var target = $(this).attr('href');
            $('a[href="' + target + '"][data-toggle="tab"]').trigger('click');
        });
    }

    // -------------------------------------------------------------------------------------------
    // Activate sticky header
    // -------------------------------------------------------------------------------------------
    function fixedHeader() {
        //Init sticky header
        var header = $('.f-header--fixed');

        $(window).scroll(function () {
            var win = $(window);
            return function () {
                header.toggleClass('fixed', win.scrollTop() > 0);
            }
        }());
    }


    // -------------------------------------------------------------------------------------------
    // Enable hovers on tables
    // -------------------------------------------------------------------------------------------
    function tableHover() {
        $('.f-table--selectable').not('.f-table--smart').each(function () {
            var table = $(this);

            table.on({
                mouseenter: function () {
                    var index = $(this).index() + 1,
                        elements = table.find('tbody tr > *:nth-child(' + index + ')');
                    if (index !== 1) {
                        elements.stop(true, true).addClass('is--highlight');
                    }
                },
                mouseleave: function () {
                    table.find('*').stop(true, true).removeClass('is--highlight');
                }
            }, 'tbody > tr > *');
        });
    }


    // -------------------------------------------------------------------------------------------
    // Scroll-top
    // -------------------------------------------------------------------------------------------
    // function scroll_top() {
    //     var win = $(window),
    //         timeo = false,
    //         scroll_top = $('.f-up'),
    //         set_status = function () {
    //             var st = win.scrollTop();

    //             if (st < 500) {
    //                 scroll_top.removeClass('is--visible');
    //             } else if (!scroll_top.is('.is--visible')) {
    //                 scroll_top.addClass('is--visible');
    //             }
    //         };

    //     scroll_top.on('click', function () {
    //         $.scrollTo(0, 500);
    //     });

    //     win.on('scroll', function () {
    //         window.requestAnimationFrame(set_status)
    //     });
    //     set_status();
    // }

    // -------------------------------------------------------------------------------------------
    // Extend tabs
    // -------------------------------------------------------------------------------------------
    $.fn.hashTabs = function () {
        var context = this;

        // Show the tab corresponding with the hash in the URL, or the first tab.
        var showTabFromHash = function () {
            var tab = getHashParams().tab,
                smooth = false;//s[0];window.location.hash;
            if (!tab || tab.length > 100) return;
            if ($(tab).parent().hasClass('f-toggle-content')) {
                tab = $(tab).parents('.f-tabs-content__item').attr('id');
                tab = '#' + tab;
                smooth = true;
            }
            var selector = tab ? 'a[href="' + tab + '"]' : 'li.active > a';
            $(selector, context).tab('show');
            syncTabs(tab);
            if (smooth) {
                setTimeout(function () {
                    $.scrollTo('.f-tabs-content__item.active .f-toggle', 500, {
                        offset: -100,
                        easing: 'easeOutExpo'
                    });
                }, 500);
            }
        }

        var syncTabs = function (tab) {
            tab = tab.split('#')[1] || tab;
            $('[data-tab-sync=' + tab + ']').each(function () {
                $(this).tab('show');
            });
        };

        //ScrollTo
        var scrollToTab = function (offset, speed, target) {
            $.scrollTo(target, speed, {
                offset: -offset,
                easing: 'easeOutExpo'
            });
        }

        // Set the correct tab when the page loads
        showTabFromHash(context);

        // Set the correct tab when a user uses their back/forward button
        $(window).on('hashchange', showTabFromHash);


        window.addSearchChangedEventListener(showTabFromHash);
        // Change the URL when tabs are clicked
        $('a', context).on('click', function (e) {
            var $this = $(this),
                hash = this.href.split('#')[1],
                tabs = $this.closest('.f-tabs--fixed'),
                content = tabs.data('target') ? $(tabs.data('target')) : $('.f-tabs-content'),
                offset = tabs.outerHeight(),
                contentPos = content.offset().top,
                currentPos = $(window).scrollTop() - offset,
                timeout = 500;
            if (!$this.data('tab-sync')) {
                changeTab(hash);
                syncTabs(hash);
            }

            if (contentPos < currentPos) {
                scrollToTab(offset, timeout, content);
                $this.data('triggered', true);
                setTimeout(function () {
                    if ($this.data('triggered')) {
                        $this.tab('show').data('triggered', false);
                    };
                }, timeout);
                //e.preventDefault();
                return false;
            }
        });

        return this;
    };

    // -------------------------------------------------------------------------------------------
    // Toggle functions
    // -------------------------------------------------------------------------------------------
    function make_toggle() {
        var toggler = $('.f-toggle'),
            body = $('body');

        toggler.each(function () {
            var inputs = $(this).find('input');

            inputs.each(function () {
                var input = $(this),
                    data = input.data(),
                    el = body.find('#' + data.target),
                    tabs = '';

                if (data.action == 'tab' && input.parent().parent('.f-competitions-toggle')) {
                    tabs = el.parent().tabbedContent({
                        onSwitch: function (tab, api) {
                            $('input[data-target="' + tab.split('#')[1] + '"]').prop('checked', true);
                        }
                    });
                }

                input.on('change', function () {
                    switch (data.action) {
                        case 'tab':
                            tabs.data('api').switch(data.target);
                            $.table_layout_fix();
                            break;
                        case 'more':
                            if (data.value == 'show') {
                                el.addClass('f-more--visible');
                            } else {
                                el.removeClass('f-more--visible');
                            }
                            $.table_layout_fix();
                            break;
                        case 'title':
                            el = body.find('.' + data.target);
                            var items = el.find('[data-title-full]');
                            items.each(function () {
                                var $this = $(this),
                                    full = $this.data('title-full'),
                                    short = $this.data('title-short'),
                                    title = data.value == 'short' ? short : full;
                                $this.text(title);
                            });
                            break;
                    }
                });
            });
        });
    }

    function generalSearch() {
        $('#f-search').each(function () {
            var container = $(this),
                field = container.find('.f-search-form__input'),
                searchResult = container.find('.f-search-form__result'),
                keyTimeout = null;

            field.on('keyup',
                function () {
                    var value = field.val();

                    clearTimeout(keyTimeout);

                    if (value.length < 4) {
                        return;
                    }

                    var sendSearchRequestDelay = 500;

                    keyTimeout = setTimeout(function () {
                        $.ajax({
                            url: '/search?q=' + value,
                            type: 'GET',
                            success: function (data) {
                                searchResult.html(data);
                            }
                        });
                    }, sendSearchRequestDelay);
                });
        });
    }

    function tabs_search() {
        $('.f-tabs-search').each(function () {
            var container = $(this),
                field = container.find('.f-tabs-search__field'),
                body = container.find('.f-tabs-search__body'),
                searchResult = container.find('.f-tabs-search-result'),
                cancelBtn = container.find('.f-tabs-search__field-cancel'),
                keyTimeout = null,
                setSearchResultsVisibility = function (visibility) {
                    container.toggleClass('f-tabs-search--typed', visibility)
                        .toggleClass('f-tabs-search--founded', visibility);
                    body.toggle(visibility);
                };


            field.on('keyup',
                function () {
                    var value = field.val();

                    clearTimeout(keyTimeout);

                    if (value.length < 4) {
                        setSearchResultsVisibility(false);
                        return;
                    }

                    var sendSearchRequestDelay = 500;

                    keyTimeout = setTimeout(function () {
                        $.ajax({
                            url: '/search/sf?q=' + value,
                            type: 'GET',
                            success: function (data) {
                                searchResult.html(data);
                            }
                            //                        ,error: function () {
                            //                            alert("error");
                            //                        }
                        });

                        setSearchResultsVisibility(true);
                    }, sendSearchRequestDelay);
                });

            searchResult.on('click', '.js-tab-result', function () {
                var $this = $(this),
                    href = $this.attr('href'),
                    target = href.substr(href.indexOf("#"));

                FaqNavigate(target);
                cancelBtn.trigger('click');
            });

            searchResult.on('click', '.js-tab-category', function () {
                var $this = $(this),
                    href = $this.attr('href'),
                    target = href.substr(href.indexOf("#"));

                $('[data-toggle="tab"][href="' + target + '"]').trigger('click');
                cancelBtn.trigger('click');
            });

            cancelBtn.on('click', function () {
                field.val('').trigger('keyup');
            });
        });
    }

    // -------------------------------------------------------------------------------------------
    // Mega Menu
    // -------------------------------------------------------------------------------------------
    function MegaMenu() {
        $('.f-header-nav > .f-header-nav__item').hoverIntent({
            over: function () {
                $(this).addClass('f-header-nav__item--opened');
            },
            out: function () {
                $(this).removeClass('f-header-nav__item--opened');
            },
            timeout: 150
        });
    }

    $('.open-popup-image').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true,
            tPrev: 'Назад',
            tNext: 'Вперед',
            tCounter: '%curr% из %total%'
        },
        mainClass: 'mfp-with-zoom mfp-img-mobile',
        image: {
            verticalFit: true
        },
        zoom: {
            enabled: true,
            duration: 300, // don't foget to change the duration also in CSS
            opener: function (element) {
                return element.find('img');
            }
        }
    });

    $('.mfp-image').magnificPopup({
        type: 'image',
        image: {
            verticalFit: true
        }
    });

    $.fn.activate_popup = function (variables) {
        var defaults = {
            autolinkElements: '.open-popup, .open-popup-filled',
            closeBtn: '<svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" width="22" height="22" viewBox="0 0 27.5 27.5"><path d="M26 0L13.7 12.3 1.4.1 0 1.5l12.3 12.3L.1 26.1l1.4 1.4 12.3-12.3 12.3 12.2 1.4-1.4-12.3-12.3L27.4 1.4z"/></svg>'
        },

            options = $.extend({}, defaults, variables),

            popup = {
                type: 'inline',
                midClick: true,
                closeMarkup: '<button title="%title%" class="mfp-close"><span class="mfp-close__text">' + options.closeBtn + '</span></button>',
                closeBtnInside: false,
                closeOnBgClick: false,
                removalDelay: 200,
                autoFocusLast: false,
                fixedContentPos: true,
                enableEscapeKey: false,
                callbacks: {
                    beforeOpen: function () {
                        if (this.st.el) {
                            //If another style
                            if (this.st.el.attr('class').indexOf('filled') > -1) {
                                this.st.mainClass = 'mfp-filled';
                            } else {
                                this.st.mainClass = 'mfp-transparent';
                                this.st.showCloseBtn = false;
                            }
                            //If we want to remove close button
                            if (this.st.el.data('mfp-closebtn') == false) {
                                this.st.showCloseBtn = false;
                            }
                            //Align popup content to top
                            if (this.st.el.data('mfp-top') == true) {
                                this.st.alignTop = true;
                            }
                        }
                        //Init alternative close button
                        methods.initClose();

                    },
                    open: function () {
                        //If exist header - move it to container
                        if (this.content.find('.mfp-header').length) {
                            this.content.find('.mfp-header').prependTo(this.container);
                        }
                        //Remove overflow from html element to leave a scrollbar for a small popup
                        if (this.st.el.attr('class').indexOf('filled') == -1) {
                            $('html').removeAttr('style');
                        }
                        //Init inner popups inside popup if it exists
                        if (this.content.find('.open-popup-filled-in').length) {
                            this.content.find('.open-popup-filled-in').on('click', function () {
                                var src = $(this).data('mfp-src');
                                methods.openFromPop(this);
                            });
                        }
                    },
                    close: function () {
                        //Move header back to content
                        if (this.container.find('.mfp-header').length) {
                            this.container.find('.mfp-header').prependTo(this.content);
                        }
                        //Open last closed popup
                        if (this.st.el && this.st.el.hasClass('open-popup-filled-in')) {
                            methods.openFromPop(this.lastOpened);
                        }
                        //If popup contain 'subtabs' - reset active tab based on main tabs
                        this.content.find('[data-tab-sync]').each(function () {
                            var item = $(this),
                                sync = item.data('tab-sync'),
                                parEl = $('body').find('a[href*=' + sync + ']');
                            if (parEl.length && parEl.hasClass('active')) {
                                item.tab('show');
                            }
                        });
                        //Add last opened element to instance for reopen it if current is opened from
                        this.lastOpened = this.st.el;
                    }
                }
            },

            methods = {
                init: function (elements) {
                    elements.each(function () {
                        var container = $(this);
                        var links = $(options.autolinkElements, this);
                        links.magnificPopup(popup);
                    });
                },
                initClose: function () {
                    $('[data-action="close-popup"]').on('click', function (e) {
                        e.preventDefault();
                        $.magnificPopup.close();
                    });
                },
                openFromPop: function (el) {
                    var curr = $(el);
                    if (!curr.length && !curr.data('mfp-src')) return;
                    $.magnificPopup.close();
                    setTimeout(function () {
                        popup = $.extend({}, popup, {
                            items: {
                                src: curr.data('mfp-src')
                            },
                            el: curr
                        });
                        $.magnificPopup.open(popup);
                    }, 200);
                }
            }

        return methods.init(this);

    }
})(jQuery);

function scrollToItem(item, offset) {
    var target = $(item).attr('href');
    offset = offset || $('.f-tabs--fixed').outerHeight();;

    $.scrollTo(target, 500, {
        offset: -offset,
        easing: 'easeOutExpo'
    });
}
function copyElemToClipboard(elem) {
    elem.select();
    try {
        document.execCommand('copy');
    } catch (err) {
        console.error(err);
    }
}
function copyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    copyElemToClipboard(textArea);
    document.body.removeChild(textArea);
}
